import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-eoiinvitation',
  templateUrl: './eoiinvitation.component.html',
  styleUrl: './eoiinvitation.component.css'
})
export class EoiinvitationComponent {
  constructor(private router: Router) { }
  isExpanded = false;
  navigate(): void {
    sessionStorage.setItem("EOIVerification",'true');
    this.router.navigate(['/eoiverification']);
  }
}

